export const LookupUrls = {
  loanPurposes: () => '/lookup/dtc-crypto-purposes',
};

export const WorkflowUrls = {
  start: () => '/workflows/dtc-crypto/dtc-crypto/start',
  checkin: (key) => `/workflows/dtc-crypto/key/${key}/checkin`,
  next: (key) => `/workflows/dtc-crypto/key/${key}/next`,
  back: (key) => `/workflows/dtc-crypto/key/${key}/back`,
  redirect: (token) => `/workflows/dtc-crypto/redirection/token/${token}`, 
  getLTVOptions: () => '/workflows/dtc-crypto/options',
  validateRoutingNumber: (routingNo) => `/workflows/helpers/bank-account/routing-number/${routingNo}`,
  resumeApplication: (key, activity) => `/workflows/dtc-crypto/${key}/step/${activity}`,
};

export const BankStatementsUrls = {
  get: (entityType, entityId, bankProcessorKey) => `/bank-statement-processor/${entityType}/${entityId}/statements?key=${bankProcessorKey}`,
  delete: (entityType, entityId, statementId, bankProcessorKey) => `/bank-statement-processor/${entityType}/${entityId}/statements/${statementId}/delete?key=${bankProcessorKey}`,
  restore: (entityType, entityId, statementId, bankProcessorKey) => `/bank-statement-processor/${entityType}/${entityId}/statements/${statementId}/restore?key=${bankProcessorKey}`
}
